export default {
  baseStyle: {
    color: 'primary.500',
  },
  sizes: {
    sm: 'small',
    lg: 'large',
  },
  defaultProps: {
    size: 'small',
  },
};
